// Shared human-readable labels for chart document `type` slugs.
//
// The on-disk document `type` is a slug (e.g. "operation-report",
// "ophthalmology-assessment"). Scenarios use 40+ distinct slugs, so a fixed
// lookup table will always miss some and leak the raw hyphenated slug to the
// student. Instead: a small OVERRIDES table only for slugs that need an
// expansion or acronym, and a title-case fallback that cleans up EVERY other
// slug (hyphens/underscores → spaces, sentence case). Result: a student never
// sees a raw hyphenated slug. Used by both <chart-navigator> (left nav) and
// <chart-viewer> (document header) so the two always agree.
// Curated labels for slugs where plain title-case isn't right — an expansion,
// acronym, or a name that must match how assessment questions refer to the
// document. Everything NOT listed here falls through to title-case (which is
// already clean for slugs like "operation-report" → "Operation report").
const OVERRIDES = {
    "preadmission-note": "Pre-admission clinic note",
    "ed-assessment": "Emergency Department assessment",
    "operative-report": "Operation note",
    "allied-health-note": "Allied health note",
    "nursing-obs-flowsheet": "Nursing observations",
};
export function friendlyDocType(type) {
    if (!type)
        return "";
    if (OVERRIDES[type])
        return OVERRIDES[type];
    const s = type.replace(/[-_]+/g, " ").trim();
    return s ? s.charAt(0).toUpperCase() + s.slice(1) : type;
}
